import { Icon, IconProps } from './Icon';

export type PlaneProps = IconProps;

export const Plane = (props: PlaneProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M8.239 4.786a.725.725 0 0 0-.178-.074.333.333 0 0 0-.122 0 .725.725 0 0 0-.178.074L1.333 8l6.428 3.214c.088.044.132.066.178.074.04.008.082.008.122 0 .046-.008.09-.03.178-.074L14.667 8 8.239 4.786Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
